/**
 * 没收保证金
 */
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

const fields = [{
    "text": "竞价品名称",
    "field": "name",
    disabled: true
}, {
    "text": "会员名称",
    "field": "memberName",
    disabled: true
}, {
    "text": "保证金",
    "field": "bond",
    disabled: true
}, {
    "text": "备注",
    "field": "remark",
    "textarea": true,
    rules: [
        { required: true, message: '备注不能为空!' },
        { max: 128, message: '备注不能超过128个字符！' },
    ]
}];


class AuctionConfiscateBondForm extends Component {


    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["lotsId"] = this.props.editData.id;
            http.post({
                url: '/auctionResult/confiscateBond',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };


    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.number ? <InputNumber min={0} max={99999999} precision={2} style={{ width: '100%' }} />
                                : item.textarea ? <Input.TextArea />
                                    : <Input disabled={item.disabled === true} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="没收保证金"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 7 }} wrapperCol={{ span: 17 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const AuctionConfiscateBond = Form.create()(AuctionConfiscateBondForm);

export default AuctionConfiscateBond;